import './styles/PowerVideos.scss';


function PowerVideos(props) {
    const {
        src
    } = props;


    return (
        <div className="card">
            <video autoPlay muted loop playsInline>
                <source src={src} type="video/mp4" />
            </video>
            <p className="label2">{props.children}</p>
        </div>
    )
}
            
export default PowerVideos;